document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.swiper-container', {
    slidesPerView: getSlidesPerView(), // Use a function to determine slides per view
    centeredSlides: true,
    initialSlide: getInitialSlide(), // Set initial slide based on screen size
    spaceBetween: 12, // Adjust spacing between slides
    freeMode: true,
    freeModeSticky: true,
    loop: shouldLoop(), // Determine if looping is enabled based on window width
    loopedSlides: getLoopedSlides(), // Number of slides to duplicate for looping
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: false,
    },
    on: {
      init: function () {
        // Adjust the initial position of the swiper
        // Using setTranslate to manually control the starting position
        this.setTranslate(0); // Start from 0 to avoid extra space
      },
    },
  });

  // Function to determine slides per view based on window width
  function getSlidesPerView() {
    return window.innerWidth < 768 ? 1 : 3; // 1 slide on mobile, 3 on larger screens
  }
// Function to determine the initial slide based on window width
  function getInitialSlide() {
    return window.innerWidth < 768 ? 0 : 1; // Start at 0 on mobile, 1 on desktop
  }
  // Function to determine if looping is enabled based on window width
  function shouldLoop() {
    return window.innerWidth < 768; // Enable loop if the screen width is less than 768px
  }

  // Function to set the number of slides to duplicate for looping
  function getLoopedSlides() {
    return window.innerWidth < 768 ? 3 : 0; // Duplicate 3 slides on mobile for more looping, 0 on larger screens
  }

  // Update Swiper on window resize
  window.addEventListener('resize', function () {
    swiper.params.slidesPerView = getSlidesPerView(); // Update slides per view
    swiper.params.loop = shouldLoop(); // Update the loop setting
    swiper.params.loopedSlides = getLoopedSlides(); // Update looped slides for mobile

    swiper.update(); // Update Swiper to reflect changes

    // Re-initialize loop if necessary
    if (swiper.params.loop) {
      swiper.loopDestroy(); // Destroy current loop state
      swiper.loopCreate(); // Recreate loop state
    }
  });
});